import Gallery, {
  GalleryFillRow,
  GalleryImageOptionType,
} from "components/Media/Gallery";

import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaSpacer from "components/Replicas/ReplicaSpacer";
import YouTubeVideo from "components/Media/YouTubeVideo";

const QuibblerMain = (props: {
  gallery: any[];
  galleryImageOptions?: GalleryImageOptionType[];
  video: any;
}) => {
  return (
    <>
      <ReplicaParagraph>
        A fully readable replica of The Quibbler, the eccentric wizarding
        magazine featured in the Harry Potter books and films. Designed to feel
        like a real issue pulled straight from the wizarding world, this version
        can be read cover to cover without breaking the illusion. It includes
        everything from bizarre articles and quirky ads to conspiracy theories
        and wild accusations.
      </ReplicaParagraph>

      <ReplicaSpacer />
      <Gallery
        images={props.gallery}
        imagesPerRow={6}
        imageOptions={props.galleryImageOptions}
        imageMaxHeight="300px"
        aspectRatio={0.75}
        fillRowAt={GalleryFillRow.end}
      />
      <ReplicaSpacer />
      <YouTubeVideo src={props.video} />
      <ReplicaSpacer />

      <ReplicaParagraph>
        The magazines are often shown only very briefly in the films — sometimes
        just the front cover is visible in the background, like in Xenophilius
        Lovegood’s house — not even a full magazine. Since there’s no time (or
        need) to design full-fledged magazines for background props, only a
        handful of pages were created for the films, and those same pages are
        reused repeatedly. These pages also don’t contain real articles (just
        filler text), so my task was to write actual content to match the
        headlines of the pre-designed pages, as well as create entirely new
        pages, layouts, and headlines for the rest of the magazine.
      </ReplicaParagraph>
    </>
  );
};

export default QuibblerMain;
